import { FC } from "react";
import { IArticleStudent, IArticleSummary } from "../../../models/statistics.model";
import { useTranslation } from "react-i18next";
import TabItem from "../TabItem";
import { ArticleContents } from "../../../pages/statistics/articles";
import StatisticsArticleSummaryTable from "./StatisticsArticleSummaryTable";
import StatisticsArticleStudentTable from "./StatisticsArticleStudentTable";
import TableEmpty from "../../common/TableEmpty";

interface IProps {
  content: ArticleContents;
  setContent: (content: ArticleContents) => void;
  isLoading?: boolean;
  summaries?: IArticleSummary[];
  students?: IArticleStudent[];
  studentTotal?: number;
  pageNo: number;
  setPageNo: (pageNo: number) => void;
  params: any;
};

const StatisticsArticlePane: FC<IProps> = ({
  content,
  setContent,
  isLoading,
  summaries = [],
  students = [],
  studentTotal = 0,
  pageNo,
  setPageNo,
  params,
}) => {
  const { t } = useTranslation();

  const renderContent = () => {
    switch (content) {
      case ArticleContents.Summary:
        return (
          <StatisticsArticleSummaryTable
            summaries={summaries}
          />
        );
      case ArticleContents.List:
        return (
          <StatisticsArticleStudentTable
            data={students}
            total={studentTotal}
            pageNo={pageNo}
            setPageNo={setPageNo}
            params={params}
          />
        );
    }
  }
  return (
    <>
      {
        summaries.length || students.length
          ? (
            <>
              <div className="comm-tab__line">
                <ul>
                  <TabItem
                    currentContent={content}
                    onSetContent={setContent}
                    tabContent={ArticleContents.Summary}
                    tabLabel={t('statistics.attendance.Tab1')}
                  />
                  <TabItem
                    currentContent={content}
                    onSetContent={setContent}
                    tabContent={ArticleContents.List}
                    tabLabel={t('statistics.attendance.Tab2')}
                  />
                </ul>
              </div>
              <div>
                {renderContent()}
              </div>
            </>
            )
          : isLoading
            ? null
            : (
              <TableEmpty text={t('statistics.appday.text1')} />
              )
      }    
    </>
  );
};

export default StatisticsArticlePane;